(function () {
  var ENTER = 0.32;
  var EXIT = 0.05;
  var sections = [];
  var frame = null;
  var reducedMq = window.matchMedia('(prefers-reduced-motion: reduce)');
  var phoneMq = window.matchMedia('(max-width: 989px)');

  function prefersReduced() {
    return reducedMq.matches;
  }

  /* The frame is position: sticky, and the next section slides over it. A
     one-shot IntersectionObserver stays "in view" for the rest of the page
     and never replays. Measure the part that is actually on screen: inside
     the viewport, and not covered by the following section. */
  function stageRatio(section) {
    var shell = section.closest('.shopify-section') || section;
    var next = shell.nextElementSibling;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var rect = section.getBoundingClientRect();
    var top = rect.top < 0 ? 0 : rect.top;
    var bottom = rect.bottom > vh ? vh : rect.bottom;

    if (next && next.getBoundingClientRect) {
      var cover = next.getBoundingClientRect().top;
      if (cover < bottom) bottom = cover;
    }

    var visible = bottom - top;
    if (visible <= 0) return 0;

    var basis = rect.height < vh ? rect.height : vh;
    if (basis <= 0) return 0;
    return visible / basis;
  }

  function snapOut(section) {
    section.classList.add('is-out');
    section.classList.remove('is-in');
    void section.offsetWidth;
    section.classList.remove('is-out');
  }

  /* Desktop fires once the tall sticky frame is a third on screen. On a
     phone that same ratio is true while the photos are still on the bottom
     edge, and the side slide finishes out of sight. Wait until the photo
     row itself has risen into the viewport. */
  function shouldEnter(section) {
    if (!phoneMq.matches) return stageRatio(section) >= ENTER;

    var vh = window.innerHeight || document.documentElement.clientHeight;
    var grid = section.querySelector('.skn-manifesto__grid') || section;
    var rect = grid.getBoundingClientRect();
    var inView = rect.top < vh * 0.72 && rect.bottom > vh * 0.22;
    return inView && stageRatio(section) >= 0.28;
  }

  function apply(section) {
    if (!section.isConnected) return;

    if (prefersReduced()) {
      section.classList.remove('is-out');
      section.classList.add('is-in');
      return;
    }

    var ratio = stageRatio(section);
    var on = section.classList.contains('is-in');

    if (on && ratio <= EXIT) snapOut(section);

    if (!section.classList.contains('is-in') && shouldEnter(section)) {
      void section.offsetWidth;
      section.classList.add('is-in');
    }
  }

  function update() {
    frame = null;
    for (var i = 0; i < sections.length; i++) apply(sections[i]);
  }

  function requestUpdate() {
    if (frame) return;
    frame = window.requestAnimationFrame(update);
  }

  function arm(section) {
    if (!section || section.dataset.sknManifestoBound === '1') return;
    section.dataset.sknManifestoBound = '1';
    sections.push(section);
    if (prefersReduced()) section.classList.add('is-in');
  }

  function boot() {
    document.querySelectorAll('[data-skn-manifesto]').forEach(arm);
    requestUpdate();
  }

  window.addEventListener('scroll', requestUpdate, { passive: true });
  document.addEventListener('scroll', requestUpdate, { passive: true, capture: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  window.addEventListener('orientationchange', requestUpdate, { passive: true });
  window.addEventListener('load', requestUpdate);
  window.addEventListener('pageshow', requestUpdate);
  window.addEventListener('hashchange', requestUpdate);

  if (reducedMq.addEventListener) {
    reducedMq.addEventListener('change', requestUpdate);
  } else if (reducedMq.addListener) {
    reducedMq.addListener(requestUpdate);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    sections = sections.filter(function (section) {
      return section.isConnected;
    });

    var root = event.target;
    if (!root || !root.querySelector) return;
    var section = root.matches('[data-skn-manifesto]')
      ? root
      : root.querySelector('[data-skn-manifesto]');
    if (!section) return;

    delete section.dataset.sknManifestoBound;
    section.classList.remove('is-in');
    section.classList.remove('is-out');
    arm(section);
    requestUpdate();
  });
})();
